import { ProductShapeIds as P } from '../settings';

// this isn't super scalable, but it's a little scalable
// lower numbers mean further to the left
// these numbers are arbitrary, but they encapsulate some meaning:
// SBC's are 0 so they'll always be all the way to the left
// VSBC's are 1 so they'll always be all the way to the left, AND they'll always be directly to the right of SBC's
// RCBC's are 1000 so they'll be to the right of SBC's and VSBC's
// VRCBC's are 1001 so they'll be to the right of SBC's and VSBC's, AND they'll always be directly the right of RCBC's
// Square BC's are 500 so they'll be in between the SBC's and RCBC's
const productShapeIdToDisplayOrderWeightMap: { [productShapeId: string]: number } = {
  [P.NA_STANDARD_BUSINESS_CARD]: 0,
  [P.NA_VERTICAL_STANDARD_BUSINESS_CARD]: 1,
  [P.NA_SQUARE_BUSINESS_CARD]: 500,
  [P.NA_ROUNDED_CORNER_BUSINESS_CARD]: 1000,
  [P.NA_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD]: 1001,

  [P.EU_STANDARD_BUSINESS_CARD]: 10,
  [P.EU_VERTICAL_STANDARD_BUSINESS_CARD]: 11,
  [P.EU_SQUARE_BUSINESS_CARD]: 510,
  [P.EU_ROUNDED_CORNER_BUSINESS_CARD]: 1010,
  [P.EU_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD]: 1011,
  [P.EU_SLIM_BUSINESS_CARD]: 1510,
  [P.EU_VERTICAL_SLIM_BUSINESS_CARD]: 1511,
};

export function getProductDisplayOrderWeight(productShapeId: string): number {
  const displayOrderWeight = productShapeIdToDisplayOrderWeightMap[productShapeId];
  if (displayOrderWeight === undefined) {
    return 10000; // default to far right
  }

  return displayOrderWeight;
}
